import React from 'react'
import {save} from '../store'
import {post} from '../components/utils'
import {connect} from 'react-redux'
import logo from '../images/large_tree_logo.png'
import CircularProgress from 'material-ui/CircularProgress';
import config from '../config'
import { browserHistory } from 'react-router'
import ReactGA from 'react-ga'

window.gapi.load('auth2', function () {
    window.gapi.auth2.init({
        client_id: config.client_id,
        hosted_domain: config.email_domain
    })
})

export default  connect( (props) => props ) (
    class extends React.Component {

        constructor() {
            super()
            this.state = {display: "block ", visibility: "hidden", show_spinner: false, signinFailure: false, not_in_payslip_access_group: false}
        }

        componentDidMount() {

            if ( config.stub_oauth ) {
                const googleUser = {
                    getAuthResponse: () => ({ id_token: "OAUTHTOKEN",})
                }
                this.onSuccess(googleUser)
            }
            else {
                window.gapi.signin2.render('my-signin2', {
                    'scope': 'profile email',
                    'width': 240,
                    'height': 50,
                    'longtitle': true,
                    'theme': 'dark',
                    'onsuccess': (googleUser) => this.onSuccess(googleUser),
                    'onfailure': () => {this.setState({signinFailure: true})}
                });
            }

            setTimeout(()=>this.setState({visibility: "visible"}), 500)
        }

        onSuccess(googleUser) {
            this.setState({display: "none", show_spinner: true})
            
            save({google_oauth_token: googleUser.getAuthResponse().id_token})
            
            Promise.all([
                post( "/api/epayslips/login", {"google_auth_token": googleUser.getAuthResponse().id_token}).then((data)=>{
                    if ( data.http_status === 403 ) {
                        browserHistory.push("/not-authorised")
                        return
                    }

                    if(data.account_error){
                        browserHistory.push('/account-error')
                    }   
                    
                    if(data.not_in_payslip_access_group){
                        this.setState({not_in_payslip_access_group: true, show_spinner: false})
                    }

                    if( !data.verified ) {
                        save( {current_user: data, ready: true} )
                        return
                    }

                    if (data.token) {
                        save({oauth_token: data.token})
                        ReactGA.event({ category: 'Navigation', action: 'Signin', label: data.store_name + " (" + data.store_id + ")" })
                    }
                    save({current_user: {...data, ready: true}})
                })

                //call more data here...

            ]).then(() => {
                save( {initial_load_complete: true})
                //browserHistory.replace('/')
            }).catch( (err) => {
                console.dir(err)
            });

        }

        render() {
            return (
                <div id="main_content" style={{textAlign: "center"}} className="flex layout-column scrollable layout-align-center">
                    <img alt="morrisons logo" height="200" src={logo}></img>
                    <h1 style={{fontWeight: "normal", color: "#004E37", fontSize: "2em"}}>My Pay</h1>
                    <div style={{padding: "10px"}}></div>
                    <div id="my-signin2" style={{display: this.state.display, visibility: this.state.visibility}} />
                    {this.state.not_in_payslip_access_group ?
                        <div style={{color: "red", textAlign: "center"}}>
                            <span>Unfortunately MyPay has not yet been rolled out for you. <br/> </span>
                            <span>You will receive further communication when it’s ready.<br/> </span>
                        </div>
                        : null  }
                    {this.state.show_spinner ?
                        <CircularProgress className="spinner" size={80} thickness={7} />
                        : null  }
                    {this.state.signinFailure ?
                        <div style={{color: "red"}}>You must sign in as a user in the {process.env.REACT_APP_EMAIL_DOMAIN} domain.</div>
                        : null}
                </div>
            )
        }
    }
)


// WEBPACK FOOTER //
// ./src/pages/login.js